<template>
  <b-form-group
    label="Ana Kategori"
    label-for="id_product_categories"
  >
    <v-select
      v-model="dataItem.id_product_categories"
      :options="dataList"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
    >
      <template v-slot:option="option">
        {{ option.title }}
        <div v-if="option.main_categories">
          <small class="text-warning">{{ option.main_categories }}</small>
        </div>
        <div v-else>
          <small class="text-info">Ana Kategori</small>
        </div>
      </template>
    </v-select>
    <small class="text-info">Ana Kategori seçilmediğinde <span class="font-weight-bolder">eklenen / düzenlenen</span> kategori ana kategori olacaktır.</small>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'MainCategoriesCard',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataList() {
      return this.$store.getters['productCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productCategories/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'main_categories.title AS main_categories',
        ],
        where: {
          'product_categories.id_product_categories': null,
        },
      })
    },
  },
}
</script>
